/**
 * Wallet Hooks
 * React Query hooks for wallet data
 *
 * @author Varun Pandey
 */

import { useQuery } from "@tanstack/react-query";
import { WalletService } from "@/services/walletService";

export const WALLET_KEYS = {
  all: ["wallet"] as const,
  balance: () => [...WALLET_KEYS.all, "balance"] as const,
  history: (page: number) => [...WALLET_KEYS.all, "history", page] as const,
};

export const useWalletBalance = () => {
  return useQuery({
    queryKey: WALLET_KEYS.balance(),
    queryFn: () => WalletService.getBalance(),
  });
};

export const useWalletHistory = (page: number = 1) => {
  return useQuery({
    queryKey: WALLET_KEYS.history(page),
    queryFn: () => WalletService.getHistory(page),
  });
};
